export enum PostPermission {
  ADMIN_ONLY = 1,
  ALL_MEMBERS = 2,
}

export const PostPermissionEnum: Record<PostPermission, string> = {
  [PostPermission.ADMIN_ONLY]: 'テナント管理者のみが投稿可',
  [PostPermission.ALL_MEMBERS]: '参加者全員が投稿可',
};

export const PostPermissionDisplayEnum: Record<PostPermission, string> = {
  [PostPermission.ADMIN_ONLY]: '管理者のみ',
  [PostPermission.ALL_MEMBERS]: '全員',
};